<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 offset-xs10 v-if="isVisible">
        <editOrder :order="order" @order_edit="orderEdit" @order_eta_add="orderETAEdit" />
      </v-flex>
      <v-toolbar class="firstPan">
        <template v-slot:extension>
          <v-tabs
            v-model="firstPanTabs"
            fixed-tabs
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab
              href="#firstPan1"
              class="primary--text"
            >
              #{{order.client_reference}}
            </v-tab>

            <v-tab
              href="#firstPan2"
              class="primary--text"
            >
              Previous Search-0
            </v-tab>

            <v-tab
              href="#firstPan3"
              class="primary--text"
            >
              Vendor Status
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="firstPanTabs">
        <v-tab-item
          v-for="i in 3"
          :key="i"
          :value="'firstPan' + i"
        >
          <v-card flat>
            <div v-if="i==1">
              <v-simple-table :fixed-header="true" height="15rem">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 10rem !important;color: #2c6d80;">
                      </th>
                      <th class="text-left" style="color: #2c6d80;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                  <td>Universal RTS Number#:</td>
                  <td>{{ order.universal_rts_number }}</td>
                </tr>
                <tr>
                  <td>PPS Number#:</td>
                  <td>{{ order.id }}</td>
                </tr>
                <tr>
                  <td>RTS Number#:</td>
                  <td>{{ order.old_rts_no }}</td>
                </tr>
                    <tr >
                      <td>Customer:</td>
                      <td>{{ order.client.name }}</td>
                    </tr>
                    <tr >
                      <td>Client Ref #:</td>
                      <td>{{ order.client_reference }}</td>
                    </tr>
                    <tr >
                      <td>Product:</td>
                      <td>{{ order.product.name }}</td>
                    </tr>
                    <tr >
                      <td>Due On:</td>
                      <td>{{ order.due_on | formatDate }}</td>
                    </tr>
                    <tr >
                      <td>Created On:</td>
                      <td>{{ order.created_on | formatDate }}</td>
                    </tr>
                    <tr >
                      <td>Borrower:</td>
                      <td>{{ order.first_borrower }}</td>
                    </tr>
                    <tr >
                        <td>Address:</td>
                        <td>{{ order.address|formatAddress }}</td>
                    </tr>
                    <tr >
                        <td>County:</td>
                        <td>{{ order.address.county.name }}</td>
                    </tr>
                    <tr >
                        <td>State:</td>
                        <td>{{ order.address.state.name }}</td>
                    </tr>
                    <tr >
                        <td>First Borrower:</td>
                        <td>{{ order.first_borrower }}</td>
                    </tr>
                    <tr >
                        <td>Last 4 of SSN::</td>
                        <td>{{ order.last_4_of_ssn }}</td>
                    </tr>
                    <tr >
                        <td>Second Borrower:</td>
                        <td>{{ order.second_borrower }}</td>
                    </tr>
                    <tr >
                        <td>Last 4 of SSN:</td>
                        <td>{{ order.last_4_of_ssn2 }}</td>
                    </tr>
                    <tr >
                        <td>Effective Date:</td>
                        <td>{{ order.effective_date | formatDate }}</td>
                    </tr>
                    <tr >
                        <td>Loan#:</td>
                        <td>{{ order.loan }}</td>
                    </tr>
                    <tr >
                        <td>Amount:</td>
                        <td>{{order.price}}</td>
                    </tr>
                    <tr >
                        <td>sbj_lien_amount:</td>
                        <td>{{ order.subject_lien_amount }}</td>
                    </tr>
                    <tr >
                        <td>sbj_lien_date:</td>
                        <td>{{ order.prepared_date | formatDate }}</td>
                    </tr>
                    <tr >
                        <td>Is Developer Deed:</td>
                        <td>{{ order.is_developer_deed }}</td>
                    </tr>
                    <tr >
                        <td>Borrower Name In Title:</td>
                        <td>{{ order.borrower_name_in_title }}</td>
                    </tr>
                    <tr >
                        <td>Search Pd St Dt:</td>
                        <td>{{ order.search_pd_st_date | formatDate }}</td>
                    </tr>
                    <tr >
                        <td>TS Identifier:</td>
                        <td>{{ order.ts_identifier }}</td>
                    </tr>
                    <tr >
                        <td>ETA Date:</td>
                        <td>{{ order_eta.eta_date | formatDate }}</td>
                    </tr>
                    <tr >
                        <td>ETA Note:</td>
                        <td>{{ order_eta.eta_notes }}</td>
                    </tr>
                    <tr >
                        <td>ETA Added On:</td>
                        <td>{{ order_eta.created_on | formatDate }}</td>
                    </tr>
                    <tr >
                        <td>ETA Added By:</td>
                        <td>{{ order_eta.created_by.username }}</td>
                    </tr>
                    <tr >
                        <td>Shared with Client:</td>
                        <td>{{ order_eta.shared_with_client ? "Yes" : "No" }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import JwtService from '@/common/jwt.service'
import editOrder from '@/components/editOrder.vue'
Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'orderSnapShotTable',
  components: {
    editOrder
  },
  data () {
    return {
      loading: true,
      firstPanTabs: null,
      isVisible: false
    }
  },
  props: {
    order: null,
    order_eta: null
  },
  mounted () {
    this.isVisible = JwtService.editOrderCheck()
  },
  methods: {
    orderEdit (res) {
      // this.order.due_on = res.due_on
      this.order = res
    },
    orderETAEdit (res) {
      // this.order.due_on = res.due_on
      this.order_eta = res
    }
  }
}
</script>

<style>

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 85%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}

.v-tab {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  font-size: .875rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  letter-spacing: .0892857143em;
  line-height: normal;
  min-width: 90px;
  max-width: 360px;
  outline: none;
  padding: 0 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  -webkit-transition: none;
  transition: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: white !important;
  color: black !important;
  font-size: 13px;
}
</style>
